import "./App.css";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Previewer from "./components/Previewer/Previewer";

function App() {
  return (
    <div className="App">
      <Header />
      <Previewer />
      <Footer />
    </div>
  );
}

export default App;
